import styled from '@emotion/styled';

export const StyledWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: #ffffff;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 5;
  margin-top: -70px;
  margin-bottom: 50px;
  left: 0;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    position: absolute;
    padding: 8px 16px;
    width: 354px;
    max-height: 33px;
    top: 90px;
    left: auto;
    right: 24px;
    margin: 0;
    bottom: auto;
  }

  .bar {
    position: absolute;
    left: 55px;
    right: 45px;
    top: 10px;
    width: auto;
    height: 10px;
    margin-bottom: 6px;
    background: linear-gradient(
      90deg,
      rgb(255, 252, 97, 0.8) 0,
      rgb(255, 131, 15, 0.8) 68%,
      rgb(230, 0, 0) 100%
    );

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      margin: 0;
      position: absolute;
      left: 65px;
      right: 55px;
      width: auto;
    }
  }

  .labels {
    display: flex;
    justify-content: space-between;

    span {
      color: ${(props) => props.theme.colors.primary};
      font-family: Inter;
      font-size: 12px;
      line-height: 14px;

      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
`;
